/* eslint-disable react/no-danger */
import { FC } from 'react'
import styled from 'styled-components'
import { ICurrPostWithNextAndPrev } from 'src/types'
import Aside from 'src/components/Aside/Aside'
import NextAndPrev from './components/NextAndPrev'
import Divider from './components/Divider'
import Meta from './components/Meta'

const PostContainer = styled.section`
  display: flex;
  margin: 0 auto;
  margin-top: 48px;
  max-width: 1200px;
`

const Article = styled.article`
  width: 100%;
  margin-left: 24px;

  h1 {
    margin-top: 0;
    text-align: center;
  }

  .media-wrap {
    margin: 20px 0;
    text-align: center !important;

    img {
      max-width: 750px;
    }
  }

  p {
    line-height: 1.6;
  }
`

interface Props {
  post: ICurrPostWithNextAndPrev
  hidePV?: boolean
}

const Post: FC<Props> = ({ post, hidePV }) => {
  const { title, contentHTML, prev, next, createdAt, pv, lastModified } = post
  return (
    <PostContainer>
      <Aside />
      <Article>
        <h1>{title}</h1>
        <Meta
          createdAt={createdAt}
          pv={pv}
          lastModified={lastModified}
          hidePV={hidePV}
        />
        <main dangerouslySetInnerHTML={{ __html: contentHTML }} />
        <Divider />
        <NextAndPrev next={next} prev={prev} />
      </Article>
    </PostContainer>
  )
}

export default Post
